/**
 * Outlined "audit-ev" chip tokens (prototype `.audit-ev` / `.mkt-card-status`).
 * A tinted-fill + colored-border + colored-text pill rendered through the
 * `@aimsos/ui` Badge with `!` overrides so the shared variant chrome doesn't
 * fight it. Single source of truth for the instance Logs status chips, the
 * Instances-tab active-count chip, and the instance-row managed/slug chips —
 * so a design tweak to the accent color changes one file, not four.
 *
 * `CHIP_BASE` is the chip chrome (20px, no Badge `py-1`). Text goes in
 * `CHIP_LABEL` so the line-box is centered in the flex chip — a raw text node
 * plus `leading-none` still sits on the font baseline and looks high.
 * Per-use modifiers (`!uppercase`, `!tracking-[0.04em]`, `font-mono`) stay at
 * the call site.
 */
export const CHIP_BASE =
  '!inline-flex !box-border !h-5 !min-h-5 !max-h-5 !items-center !justify-center !border !py-0 !px-2 !text-[10px] !font-semibold !leading-none';

export const CHIP_LABEL = 'inline-flex h-full items-center leading-none';

export const CHIP_TONE = {
  accent: '!border-[rgba(43,127,255,0.30)] !bg-[rgba(43,127,255,0.10)] !text-[#2B7FFF]',
  danger: '!border-[rgba(239,68,68,0.30)] !bg-[rgba(239,68,68,0.10)] !text-[#EF4444]',
  neutral: '!border-slate-400/20 !bg-slate-400/[0.08] !text-content-faint',
  purple: '!border-purple-500/30 !bg-purple-500/10 !text-purple-400',
};
